import { useGetMeetingTypes } from "@/hooks/queryHooks/configHooks";
import type { Meeting } from "@repo/types";

export const MeetingTypeName = ({ type }: { type: Meeting["meetingType"] }) => {
  const { data: meetingTypes } = useGetMeetingTypes();
  return (
    <p>
      {meetingTypes?.meetingTypes.find(
        (meetingType) => meetingType.value === type
      )?.label ?? type}
    </p>
  );
};
